var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "voice-agent-call-message", style: _vm.messageColors },
    [
      _c(
        "div",
        {
          staticClass: "call-content",
          staticStyle: { cursor: "pointer" },
          on: { click: _vm.showDetails },
        },
        [
          _c("div", { staticClass: "call-icon" }, [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v(_vm._s(_vm.getCallIcon())),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "call-info" }, [
            _c("div", { staticClass: "call-title" }, [
              _vm._v(_vm._s(_vm.getCallTitle())),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "call-status-row" },
              [
                _c(
                  "a-tag",
                  {
                    attrs: {
                      color: _vm.getStatusColor(_vm.callData.call_status),
                    },
                  },
                  [_vm._v(_vm._s(_vm.callData.call_status))]
                ),
                _vm._v(" "),
                _vm.callData.start_timestamp
                  ? _c("span", { staticClass: "call-duration" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.formatDuration(
                              _vm.callData.start_timestamp,
                              _vm.callData.end_timestamp
                            )
                          ) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "call-number-row" }, [
              _c("div", { staticClass: "call-from" }, [
                _c("span", { staticClass: "call-label" }, [_vm._v("Arayan:")]),
                _vm._v(" "),
                _c("span", { staticClass: "call-value" }, [
                  _vm._v(_vm._s(_vm.callData.from_number || "Bilinmiyor")),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "call-to" }, [
                _c("span", { staticClass: "call-label" }, [_vm._v("Aranan:")]),
                _vm._v(" "),
                _c("span", { staticClass: "call-value" }, [
                  _vm._v(_vm._s(_vm.callData.to_number || "Bilinmiyor")),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "call-actions",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _vm.hasDetails()
                  ? _c(
                      "a-button",
                      {
                        attrs: { type: "link", size: "small" },
                        on: { click: _vm.showDetails },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex gap-5 align-items-center" },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("info"),
                            ]),
                            _vm._v(
                              "\n                        Arama Detaylarını Göster\n                    "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAudioRecording()
                  ? _c(
                      "a-button",
                      {
                        attrs: { type: "link", size: "small" },
                        on: { click: _vm.togglePlayAudio },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex gap-5 align-items-center" },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v(
                                _vm._s(_vm.isPlaying ? "pause" : "play_arrow")
                              ),
                            ]),
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.isPlaying
                                    ? "Ses Kaydını Durdur"
                                    : "Ses Kaydını Oynat"
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("audio", {
        ref: "miniAudioPlayer",
        staticStyle: { display: "none" },
        attrs: { src: _vm.callData.recording_url },
      }),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Arama Detayları", width: "800px", footer: null },
          on: { cancel: _vm.closeModal },
          model: {
            value: _vm.detailsModalVisible,
            callback: function ($$v) {
              _vm.detailsModalVisible = $$v
            },
            expression: "detailsModalVisible",
          },
        },
        [
          _vm.callData
            ? _c("div", { staticClass: "call-details" }, [
                _c("div", { staticClass: "call-info-details" }, [
                  _c("div", { staticClass: "call-info-item" }, [
                    _c("strong", [_vm._v("Call ID:")]),
                    _vm._v(" " + _vm._s(_vm.callData.call_id)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "call-info-item" }, [
                    _c("strong", [_vm._v("Zaman:")]),
                    _vm._v(
                      " " + _vm._s(_vm.formatDate(_vm.callData.start_timestamp))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "call-info-item" }, [
                    _c("strong", [_vm._v("Süre:")]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatDuration(
                            _vm.callData.start_timestamp,
                            _vm.callData.end_timestamp
                          )
                        ) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "call-info-item" }, [
                    _c("strong", [_vm._v("Arayan:")]),
                    _vm._v(" " + _vm._s(_vm.callData.from_number)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "call-info-item" }, [
                    _c("strong", [_vm._v("Aranan:")]),
                    _vm._v(" " + _vm._s(_vm.callData.to_number)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "call-info-item" },
                    [
                      _c("strong", [_vm._v("Durum:")]),
                      _vm._v(" "),
                      _c(
                        "a-tag",
                        {
                          attrs: {
                            color: _vm.getStatusColor(_vm.callData.call_status),
                          },
                        },
                        [_vm._v(_vm._s(_vm.callData.call_status))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.callData.disconnection_reason
                    ? _c(
                        "div",
                        { staticClass: "call-info-item" },
                        [
                          _c("strong", [_vm._v("Bağlantı Kesilme Nedeni:")]),
                          _vm._v(" "),
                          _c(
                            "a-tag",
                            {
                              attrs: {
                                color: _vm.getDisconnectionReasonColor(
                                  _vm.callData.disconnection_reason
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.formatDisconnectionReason(
                                      _vm.callData.disconnection_reason
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getCallCost()
                    ? _c("div", { staticClass: "call-info-item" }, [
                        _c("strong", [_vm._v("Maliyet:")]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.getCallCost()) +
                            " ₺\n                "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.hasTranscript()
                  ? _c("div", { staticClass: "transcript-container" }, [
                      _c("h3", [_vm._v("Konuşma Metni")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "transcript-content" },
                        _vm._l(
                          _vm.getTranscriptLines(),
                          function (line, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "transcript-line",
                                on: {
                                  click: function ($event) {
                                    return _vm.seekToTranscriptLine(index)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(line) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasCallSummary()
                  ? _c("div", { staticClass: "call-summary" }, [
                      _c("h3", [_vm._v("Arama Özeti")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.callData.call_analysis.call_summary)),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAudioRecording()
                  ? _c("div", { staticClass: "audio-player-container" }, [
                      _c("h3", [_vm._v("Ses Kaydı")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "modern-audio-player" }, [
                        _c("div", { staticClass: "audio-player-info" }, [
                          _c(
                            "i",
                            { staticClass: "material-icons audio-icon pulse" },
                            [_vm._v("music_note")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "audio-title-container" }, [
                            _c("div", { staticClass: "audio-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatDate(_vm.callData.start_timestamp)
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "audio-player-wrapper" }, [
                          _c("audio", {
                            ref: "audioPlayer",
                            staticStyle: { width: "100%" },
                            attrs: {
                              controls: "",
                              src: _vm.callData.recording_url,
                            },
                          }),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }